/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  let refreshing = false

  // 当新的 service worker 接管页面时，刷新页面
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return
    refreshing = true
    window.location.reload()
  })

  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered (registration) {
      console.log('Service worker has been registered.')
      // 每60秒检查一次更新
      setInterval(() => {
        registration.update()
      }, 60 * 1000)
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated (registration) {
      console.log('New content is available; please refresh.')
      // 显示更新通知
      const updateNotification = document.createElement('div')
      updateNotification.id = 'app-update-notification'
      updateNotification.innerHTML = `
        <div style="
          position: fixed;
          bottom: 20px;
          left: 50%;
          transform: translateX(-50%);
          z-index: 99999;
          background: #323233;
          color: #fff;
          padding: 16px 24px;
          border-radius: 8px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.3);
          display: flex;
          align-items: center;
          gap: 16px;
          font-size: 15px;
          line-height: 1.5;
        ">
          <span>📢 新版本已发布，点击刷新获取最新内容</span>
          <button onclick="this.parentElement.remove();window.location.reload()" style="
            background: #568156;
            color: #fff;
            border: none;
            padding: 8px 20px;
            border-radius: 4px;
            cursor: pointer;
            font-size: 14px;
            white-space: nowrap;
          ">立即刷新</button>
          <button onclick="this.parentElement.remove()" style="
            background: transparent;
            color: #999;
            border: 1px solid #555;
            padding: 8px 12px;
            border-radius: 4px;
            cursor: pointer;
            font-size: 14px;
            white-space: nowrap;
          ">稍后</button>
        </div>
      `
      document.body.appendChild(updateNotification)
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}